import React, { Component } from 'react';
import { BreadCumb, DataTables, NavBar, TimeOut, EntryTransfers } from "../../components";
import config from "../../config";
import moment from "moment";
import { ApiClient } from "../../libs/apiClient";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { connect } from "react-redux";
import $ from 'jquery';

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Serie", value: true },//0
    { title: "Num.Doc", value: true },//1
    { title: "Cliente", value: true },//2
    { title: "Nombre", value: true },//3
    { title: "De Almacén", value: true },//4
    { title: "Almacén destino", value: true },//5
    { title: "Tipo de Salida del Documento", value: true },//6
    { title: "Centro de Costo (CeCo)", value: true },//7
    { title: "Código Motivo de Traslado", value: true },//8
    { title: "Fecha Cont.", value: true },//9
    { title: "Empl. Ventas", value: true },//10
    { title: "Titular Doc.", value: true },//11
    { title: "Comentarios", value: true },//12
    { title: "Total", value: true },//13
    { title: "Estatus", value: true },//14
    { title: "Observacion del Estado", value: true },//15
    { title: "Estado del documento", value: true },//16
    { title: "Número de Guía", value: true },//17
    { title: "Docs Vencidos", value: true },//18
    { title: "Facturado", value: true },//19
    { title: "Pagado", value: true },//20
    { title: "Vencido", value: true }//21
];

class TransfersView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            entryTransfersData: [],
            mountEntryTransfers: false
        }

    }

    componentDidMount = async () => {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liTraslado");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
        }
        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {

        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        const defaultWhs = user?.Branch?.ProjectCode ?? "--";
        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            table: "OWTR",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--',
            searchByWhs: defaultWhs ? defaultWhs === '' ? '--' : defaultWhs : '--'
        };

        enableSpinner(true);
        let transfersListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (transfersListResponse.status === SERVICE_RESPONSE.SUCCESS) {
            /*let dataSerie = {
                docType: "67",
                docSubType: "--"
            };
            enableSpinner(true);
            let seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);

            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
            
            let ValidateSeries = user.U_FMB_ValidateSeriesOWTR ? user.U_FMB_ValidateSeriesOWTR : "";

            if (!user || ValidateSeries == "") {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
                });

                this.setState({
                    data: [],
                });
                return;
            }

            let seriesUsers = ValidateSeries.split("|");


            let newArraySeries = [];
            seriesUsers.map(serieUser => {
                seriesResponse.data.map(serieResponse => {
                    if (serieResponse.Series == serieUser) {
                        newArraySeries.push(serieResponse);
                    }
                })
            })
            
            if (newArraySeries.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "El usuario no tiene serie permitida de escritura y lectura"
                });
                return;
            }

                        
            
            let newDocumentsfilterSeries = [];

                transfersListResponse.data.map(document => {   
                    newArraySeries.map(serie => {
                    if(document.SeriesCode == serie.Series){
                        newDocumentsfilterSeries.push(document);
                    }
                })
            })*/

            let newDocumentsFilterSeries = transfersListResponse.data;

            this.setState({
                data: newDocumentsFilterSeries,
            });
            return;
        }
        // showAlert({type: 'error', message: transfersListResponse.message});
    }


    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    //#region transfers actions #####
    ShowEntryTransfers = async () => {
        await this.setState({ mountEntryTransfers: true })
        $('#entryTransfers').modal('show');
        this.GetMyStockTransfers(1);
    }

    GetMyStockTransfers = async (typeTransfer) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.getMyStockTransfers(typeTransfer);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message ?? ''}` });
            return;
        }

        if (responseApi.data.length === 0) {
            showAlert({ type: 'info', message: `No se encontraron resultados` });
            // return;
        }

        await this.setState({
            entryTransfersData: responseApi.data ?? [],

        })
    }

    CloseActions = () => {
        this.setState({
            entryTransfersData: [],
            mountEntryTransfers: false
        })
    }
    //#endregion

    render() {
        const { headers, data, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'TRASLADO DE MERCANCÍA'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <label id="linkOrdProv" className="text-muted">
                            &nbsp;TRASLADO DE MERCANCÍA
                        </label>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"transfers"}
                        data={data}
                        search={this.searchDocuments}
                        GetEntryTransfersData={this.ShowEntryTransfers}
                    />
                    {this.state.mountEntryTransfers &&
                        <EntryTransfers
                            data={this.state.entryTransfersData}
                            GetMyStockTransfers={this.GetMyStockTransfers}
                            CloseActions={this.CloseActions}
                        />

                    }

                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TransfersView);